import Vue from 'vue'
import board from './utility/Board';
import AppAgGrid from './ag-grid/View';
import text from './text/Text';
import { AgGridVue } from 'ag-grid-vue';

Vue.component('app-board', board);
Vue.component('app-ag-grid', AppAgGrid);
Vue.component('ag-grid-vue', AgGridVue);
Vue.component('article-box', AgGridVue);
Vue.component('t-text', text);
